
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_vrgzu_1tqyj_141",
  "recovery": "awsui_recovery_vrgzu_1tqyj_176"
};
  